"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocationStore = void 0;
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
const i18n_1 = __importDefault(require("../../common/i18n"));
//const userCode = "d87e5fc01be7425b919ef591a6ce3d08";
exports.useLocationStore = (0, pinia_1.defineStore)("locationStore", {
    state: () => ({
        locations: [],
    }),
    getters: {},
    actions: {
        getLocations() {
            this.locations = [];
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)("/api/locations/getbyprefix", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    //body: JSON.stringify({ userCode: userCode }),
                })
                    .then((response) => {
                    if (typeof response.error !== "undefined") {
                        // refresh failed
                        reject(i18n_1.default.trans("frontend_location_error", "No locations found!", "frontend"));
                        return;
                    }
                    response.forEach((item) => {
                        this.locations.push(item);
                    });
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        },
    },
});
